// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import classNames from 'classnames'
import { Button, message, Modal, Spin, Typography } from 'antd'
import './index.less'
import CreateDownloadRequest from './CreateDownloadRequest'
import { connect } from 'react-redux'
import PreDownloadList from './PreDownloadList'
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons'
import { withRouter } from 'react-router-dom'
import {DOWNLOAD_TASK_TYPE} from '../../constants'

class DownloadVideo extends React.Component {
  handleCancelClick = () => {
    const { clearDownloadPreTaskList, clearEditingPreTask, resetMode, mode, clearGeofence, onClear, changeTaskType, setCityStatus } = this.props
    Modal.confirm({
      title: 'Are you sure you want to cancel?',
      onOk: () => {
        clearDownloadPreTaskList()
        clearEditingPreTask()
        onClear()

        if (mode === 'update') {
          clearGeofence()
          resetMode()
          changeTaskType(DOWNLOAD_TASK_TYPE.DEVICE)
          setCityStatus(false)
        }
        // setDownloadPreTaskShow(false)
      }
    })
  }

  handleDownloadClick = enable => {
    const {
      createDownloadTask,
      updateDownloadTask,
      mode,
      resetMode,
      clearDownloadPreTaskList,
      clearEditingPreTask,
      clearGeofence,
      history
    } = this.props
    if (!enable) {
      return message.info('please add task first!')
    }
    const fn = mode === 'update' ? updateDownloadTask : createDownloadTask
    Modal.confirm({
      title: 'Are you sure you want to upload images from camera?',
      content: '',
      onOk: () => {
        return fn()
          .then(() => {
            Modal.success({
              title: 'Submit Success',
              content: 'You can check the process in Upload Pending List',
              onOk: () => {
                if (mode === 'update') {
                  clearDownloadPreTaskList()
                  clearEditingPreTask()
                  clearGeofence()
                  resetMode()
                }
                history.push('/uploadqueue')
              },
              okText: 'Go to Upload Pending List',
              cancelText: 'Back',
              maskClosable: true
            })
          })
          .catch(err => {
            message.error(err.toString())
          })
      }
    })
  }

  async handleExpandIconClick () {
    const { setDownloadShow, isDownloadShow } = this.props
    setDownloadShow(!isDownloadShow)
  }
  componentWillUnmount () {
    const {setCityStatus, cityFilterStatus} = this.props
    if(cityFilterStatus){
      setCityStatus(false)
    }
  }

  render () {
    const {
      isDownloadShow,
      isDownloadPreTaskShow,
      isDownloadPendingListShow,
      setDownloadPreTaskShow,
      preTaskList,
      loading,
      mode
    } = this.props
    const createTaskEnable = (preTaskList && preTaskList.length) || mode === 'update'
    const innerStyle = classNames('download-video-inner', {
      'download-video-inner-hidden': !isDownloadShow
    })
    return (
      <>
        <div className={classNames('download-video', { expand: isDownloadShow })}>
          <div className={innerStyle}>
            <Spin spinning={loading} tip='waiting map ready...'>
              <div className='download-video-main'>
                <div className='description'>
                  <Typography.Title onClick={() => setDownloadPreTaskShow(!isDownloadPreTaskShow)} level={4}>
                    Imagery Upload
                  </Typography.Title>
                  <Typography.Text type='secondary'>
                    {/*You can select geofence,road or camera to */}
                    upload imagery from cameras
                  </Typography.Text>
                </div>

                {isDownloadPreTaskShow && <CreateDownloadRequest />}

                {isDownloadPreTaskShow && <PreDownloadList />}
              </div>
            </Spin>
            {isDownloadPreTaskShow && (
              <div style={{ marginTop: 12 }}>
                <Button
                  type='primary'
                  block
                  style={{ marginBottom: 12, opacity: createTaskEnable ? 1 : 0.5 }}
                  onClick={() => this.handleDownloadClick(createTaskEnable)}
                >
                  Upload
                </Button>
                <Button type='secondary' onClick={this.handleCancelClick} block>
                  Cancel
                </Button>
              </div>
            )}
          </div>
          {!isDownloadPendingListShow && (
            <div onClick={this.handleExpandIconClick.bind(this)} className='expand-icon'>
              {isDownloadShow ? <CaretLeftOutlined /> : <CaretRightOutlined />}
            </div>
          )}
        </div>
      </>
    )
  }
}

const mapState2Props = ({ download ,city}) => ({ ...download, cityFilterStatus: city.disabled })
const mapDispatch2Props = ({ download, geofence, city}) => ({ ...download, clearGeofence: geofence.clearSelectEnable,setCityStatus: city.setCityStatus })
export default withRouter(connect(mapState2Props, mapDispatch2Props)(DownloadVideo))
